import { Pipe, PipeTransform } from '@angular/core';
import { get, reduce } from 'lodash';

@Pipe({
  standalone: false,
  name: 'servicePackagesCount'
})
export class ServicePackagesCountPipe implements PipeTransform {
  transform(packages: any[]): number {
    return reduce(packages, (sum, p) => sum + get(p, 'count', 0), 0);
  }
}
